import React from "react";
import Marquee from "react-fast-marquee";
import { useLang, IMAGES, GALLERY } from "../i18n";

const ImgCard = ({ src }) => (
  <div className="relative mx-3 h-56 md:h-72 w-80 md:w-[26rem] shrink-0 overflow-hidden rounded-2xl border border-[var(--border)] group">
    <img src={src} alt="" className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
    <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)]/60 to-transparent opacity-60 group-hover:opacity-20 transition-opacity duration-500" />
    <span className="absolute top-4 left-4 w-5 h-5 border-t border-l border-[var(--gold)]/50" />
    <span className="absolute bottom-4 right-4 w-5 h-5 border-b border-r border-[var(--gold)]/50" />
  </div>
);

export const Gallery = () => {
  const { lang } = useLang();
  const rowA = GALLERY.slice(0, 5).map((k) => IMAGES[k]);
  const rowB = GALLERY.slice(5).map((k) => IMAGES[k]);
  return (
    <section data-testid="gallery-section" className="relative py-24 md:py-32 bg-[var(--bg-secondary)] border-y border-[var(--border)] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-12 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <span className="h-px w-10 bg-[var(--gold)]" />
          <span className="overline text-[11px] text-[var(--gold)]">
            {lang === "it" ? "GALLERIA · IN AZIONE" : "GALLERY · IN ACTION"}
          </span>
        </div>
        <span className="overline text-[10px] text-[var(--text-secondary)] hidden md:block">
          {lang === "it" ? "scorrimento automatico" : "auto scroll"}
        </span>
      </div>

      <div className="space-y-5">
        <Marquee speed={45} gradient gradientColor="#F4F6EF" gradientWidth={120} pauseOnHover>
          {rowA.map((src, i) => <ImgCard key={i} src={src} />)}
        </Marquee>
        <Marquee speed={45} direction="right" gradient gradientColor="#F4F6EF" gradientWidth={120} pauseOnHover>
          {rowB.map((src, i) => <ImgCard key={i} src={src} />)}
        </Marquee>
      </div>
    </section>
  );
};
